import { useState } from 'react'
import Link from 'next/link'
import BidInput from '../../elements/BidInput/BidInput'
import BidButton from '../../elements/BidButton/BidButton'
import styles from './ForgotPasswordForm.module.scss'
import bidapi from '../../api/bidapi'
import isValidEmail from '@utilities/functions/isValidEmail'

export default function ForgotPasswordForm() {
  const [email, setEmail] = useState<string>('')
  const [emailSubmitted, setEmailSubmitted] = useState<string>('')
  const [notification, setNotification] = useState<any>({})

  const handleSubmitEmail = async (e: any) => {
    e.preventDefault()
    if (!isValidEmail(email))
      return setNotification({ message: 'Invalid E-mail', success: false })
    if (emailSubmitted === email) {
      setNotification({
        message: 'Request for this email already submitted',
        success: false,
      })
    } else {
      const result = await bidapi({
        method: 'POST',
        url: `${
          process.env.NEXT_PUBLIC_AUCTION_API
        }/bidder/submitForgotPassword?email=${encodeURIComponent(email)}`,
      })

      setEmailSubmitted(email)
      setNotification(result)
    }
  }

  return (
    <div
      className={`${styles.form_block} mx-auto flex w-full items-center flex-col mobile-padding`}
    >
      <h2 className={`${styles.forgot_password_title} font-bold`}>
        Forgot Password
      </h2>
      <div className="w-full">
        <div
          className={`${!notification.message ? 'hidden' : ''} ${
            notification.success
              ? 'bg-bidfta-blue-dark'
              : styles.notification_error
          } md:mx-7 mb-7 py-3 px-9 rounded-md text-white font-bold text-center`}
        >
          {notification.message}
        </div>
      </div>
      <form
        onSubmit={handleSubmitEmail}
        className={`${styles.submit_email} flex flex-col items-center mb-20 md:mb-40 xl:mb-60 bg-white`}
      >
        <div className="w-full mb-7">
          <BidInput
            inputValue={email}
            setInputValue={setEmail}
            theme="blue"
            label="E-mail Address"
            labelBold
            placeholder="E-mail Address"
            twcss="text-xs"
            type="email"
          />
        </div>
        <div className="w-full mb-7">
          <BidButton
            label="Submit"
            theme="blue-light"
            callBack={handleSubmitEmail}
            width="full"
            disabled={email === ''}
          />
        </div>
        <div className={`${styles.back_to_login} flex`}>
          <p className="text-bidfta-blue-light cursor-pointer font-semibold">
            <Link href="/account/login" className="underline">
              Back to Login
            </Link>
          </p>
        </div>
      </form>
    </div>
  )
}
